module.exports = __webpack_public_path__ + "img/multimodal_mental_health_dx_1.6bcde49e.png";